import {z} from 'zod';

export const scannedLicensePlateSchema = z.object({
  licensePlate: z.string().nullish(),
});

export type ScannedLicensePlate = z.infer<typeof scannedLicensePlateSchema>;
